import { Controller } from "@hotwired/stimulus";

import { trackClick } from "../utils/recommender";

// Connects to data-controller="recommender-click-tracking"
export default class extends Controller {
  static values = { subKind: String, url: String, meta: Object };

  handleClick() {
    trackClick(this.subKindValue, this.urlValue, this.metaValue);
  }
}
